import { cn } from '@/lib/utils';

export default function H5({ children, className }: { children: string; className?: string }) {
    return <h5 className={cn('text-h6 lg:text-h5 font-medium', className)}>{children}</h5>;
}
